{
    "title": "Keep your documents on hand to streamline the onboarding process.",
    "advice": "The process uses to be long 10 minutes to complete.",
    "corporationdownload": "Later on the onboarding, you will be asked to upload the Beneficial Owner Agreement. Please, download and fill it with your company information.",
    "mobileadvice": "The corporation onboarding can't be completed on mobile device. Please, use a desktop instead."
}